import { createAsyncThunk } from '@reduxjs/toolkit';
import { FetchEmployeeStatusesResponse, FetchEmployeeMaritalStatusesResponse } from '../../../../types/b2tRatibiPlus';
import { b2bThriftPlan } from '../../../../api/b2bThriftPlan';

export const fetchEmployeeStatuses = createAsyncThunk<FetchEmployeeStatusesResponse>(
  'employeeStatuses/fetch-all',
  async () => {
    const response = await b2bThriftPlan.fetchEmployeeStatuses();
    return response;
  },
);

export const fetchEmployeeMaritalStatuses = createAsyncThunk<FetchEmployeeMaritalStatusesResponse>(
  'employeeStatuses/fetch-marital-statuses',
  async () => {
    const response = await b2bThriftPlan.fetchEmployeeMaritalStatuses();
    return response;
  },
);
